import * as React from "react";

import {PhosphorIcon} from "@khanacademy/wonder-blocks-icon";

import chatIcon from "@phosphor-icons/core/bold/chat-bold.svg";

export const ChatIcon = (): React.ReactElement => (
    <PhosphorIcon icon={chatIcon} size="small" />
);
